// session-time.ts — the sidebar's time formatting (shared by the Chats list,
// folders and the Trash). Pure; no Svelte.

// Open WebUI's compact time-ago (`now`, `5m`, `3h`, `2d`, `1w`, `1y`).
export function formatAgo(ts: number, now: number = Date.now()): string {
	const diffSec = Math.max(0, Math.floor((now - ts) / 1000));
	const min = Math.floor(diffSec / 60);
	if (min < 1) return 'now';
	if (min < 60) return `${min}m`;
	const hours = Math.floor(min / 60);
	if (hours < 24) return `${hours}h`;
	const days = Math.floor(hours / 24);
	if (days < 7) return `${days}d`;
	const weeks = Math.floor(days / 7);
	if (days < 365) return `${weeks}w`;
	return `${Math.floor(days / 365)}y`;
}

// Full date for the tooltip (the compact label is deliberately terse).
export function formatFull(ts: number): string {
	return new Date(ts).toLocaleString([], {
		day: 'numeric',
		month: 'short',
		hour: '2-digit',
		minute: '2-digit',
	});
}
